import { observable, action } from 'mobx'

export default class {
    @observable loading: boolean = false

    @action setLoading = (loading: boolean) => {
        this.loading = loading
    }
}
